export interface Option {
  value: string;
  label: string;
}

export interface OrderFormData {
  state: string;
  district: string;
  neighborhood: string;
  fullName?: string;
  street?: string;
  zipCode?: string;
  number?: string;
  cmpNumber?: string;
  region: string;
}

export interface UpdateOrder {
  state: string;
  district: string;
  neighborhood: string;
  fullName?: string;
  street: string;
  zipCode: string;
  number?: string;
  cmpNumber?: string;
  region: string;
}

export interface SepomexResponse {
  state: string;
  city: string;
  settlements: Option[];
}

export interface Address {
  firstName: string;
  lastName: string;
  address1: string;
  address2: string | null;
  city: string;
  province: string;
  country: string;
  zip: string;
  phone: string | null;
}

export interface LineItem {
  id: number;
  title: string;
  quantity: number;
  price: string;
  sku: string;
}

export interface ShopifyOrder {
  id: number;
  shopifyOrderId: string;
  orderNumber: string;
  totalPrice: string;
  currency: string;
  financialStatus: string;
  fulfillmentStatus: string | null;
  customerEmail: string;
  customerPhone: string | null;
  shippingAddress: Address;
  billingAddress: Address;
  lineItems: LineItem[];
  status: string;
  csf: string;
  rfc: string;
  cfdiUse: string | null;
  paymentMethod: string | null;
  taxRegime: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface DeliveryStatus {
  status: string;
  trackingNumber: string;
  pickingDate: string | null;
  deliveryDate: string | null;
  departureDate: string | null;
}

export interface ApiResponse {
  message: string;
  data: ShopifyOrder;
  delivery: DeliveryStatus | null;
} 

export interface OrderResponse{
  data: ShopifyOrder;
  delivery: DeliveryStatus | null;
}

export const regionOptions: Option[] = [
  { value: 'AGS', label: 'Aguascalientes' },
  { value: 'BC', label: 'Baja California' },
  { value: 'BCS', label: 'Baja California Sur' },
  { value: 'CHI', label: 'Chihuahua' },
  { value: 'CHS', label: 'Chiapas' },
  { value: 'CMP', label: 'Campeche' },
  { value: 'CMX', label: 'Ciudad de México' },
  { value: 'COA', label: 'Coahuila de Zaragoza' },
  { value: 'COL', label: 'Colima' },
  { value: 'DGO', label: 'Durango' },
  { value: 'GRO', label: 'Guerrero' },
  { value: 'GTO', label: 'Guanajuato' },
  { value: 'HGO', label: 'Hidalgo' },
  { value: 'JAL', label: 'Jalisco' },
  { value: 'MCH', label: 'Michoacán de Ocampo' },
  { value: 'MEX', label: 'México' },
  { value: 'MOR', label: 'Morelos' },
  { value: 'NAY', label: 'Nayarit' },
  { value: 'NL', label: 'Nuevo León' },
  { value: 'OAX', label: 'Oaxaca' },
  { value: 'PUE', label: 'Puebla' },
  { value: 'QRO', label: 'Querétaro' },
  { value: 'QR', label: 'Quintana Roo' },
  { value: 'SLP', label: 'San Luis Potosí' },
  { value: 'SIN', label: 'Sinaloa' },
  { value: 'SON', label: 'Sonora' },
  { value: 'TAB', label: 'Tabasco' },
  { value: 'TMS', label: 'Tamaulipas' },
  { value: 'TLX', label: 'Tlaxcala' },
  { value: 'VER', label: 'Veracruz de Ignacio de la Llave' },
  { value: 'YUC', label: 'Yucatán' },
  { value: 'ZAC', label: 'Zacatecas' }
];